import React, { useState } from 'react';

const AudienceStep = ({ onComplete, onBack, initialAnswers }) => {
  const [selectedFeeling, setSelectedFeeling] = useState(
    initialAnswers?.dreamFeeling || ''
  );

  const feelings = [
    {
      id: 'moved',
      emoji: '😢',
      title: 'Moved to tears by your emotion',
      description: 'They feel the depth of your character\'s story and are emotionally connected'
    },
    {
      id: 'amazed',
      emoji: '🔥',
      title: 'On their feet applauding your fire',
      description: 'They\'re energized by your passion, power, and commanding stage presence'
    },
    {
      id: 'joyful',
      emoji: '😊',
      title: 'Smiling because you brought them joy',
      description: 'They feel uplifted, charmed, and delighted by your performance'
    },
    {
      id: 'awed',
      emoji: '✨',
      title: 'In awe of your grace and control',
      description: 'They\'re mesmerized by your technical perfection and ethereal beauty'
    }
  ];

  const handleSelectFeeling = (feelingId) => {
    setSelectedFeeling(feelingId);
  };

  const handleNext = () => {
    if (selectedFeeling) {
      onComplete({ dreamFeeling: selectedFeeling });
    }
  };

  return (
    <div className="quiz-step">
      <h2>You're about to perform for an audience. How do you want them to feel when you finish?</h2>
      <p>This reveals your artistic goals and helps match you with variations that achieve that impact.</p>
      
      <div className="options-grid">
        {feelings.map((feeling) => (
          <div
            key={feeling.id}
            className={`option-card ${selectedFeeling === feeling.id ? 'selected' : ''}`}
            onClick={() => handleSelectFeeling(feeling.id)}
          >
            <h3>
              <span className="emoji">{feeling.emoji}</span>
              {feeling.title}
            </h3>
            <p>{feeling.description}</p>
          </div>
        ))}
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={!selectedFeeling}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default AudienceStep; 